export enum TabTypes {
  Prematch,
  Live,
}
